import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import If from 'components/If';
import { getFromBrandConfig } from 'brand-config';
import { ACTIVATE_CODE_PATH } from 'services/enrollment/config';
import { QaHeader } from 'testdata/constants';
import useHeaderRouteFlags from '../useHeaderRouteFlags';
import styles from './Menu.module.scss';

type RedeemCtaProps = {
  onDrawerClose?: () => void;
};

/** "Have an activation code? / Redeem Now" CTA in the signed-out sign-in header. */
function RedeemCta({ onDrawerClose }: RedeemCtaProps) {
  const navigate = useNavigate();
  const { isSignInRoute } = useHeaderRouteFlags();
  const showRedeemActivationCode = getFromBrandConfig(
    'showRedeemActivationCode',
  );

  const showCta = !!showRedeemActivationCode && isSignInRoute;

  /* `replace` so Back from the activation flow does not return to sign-in. */
  const handleRedeem = () => {
    onDrawerClose?.();
    navigate(ACTIVATE_CODE_PATH, { replace: true });
  };

  return (
    <If condition={showCta}>
      <Button
        type='primary'
        className={`${styles.redeemButton} verticalFlex gap2`}
        onClick={handleRedeem}
        data-qa-selector={QaHeader.buttonRedeemActivationCode}
      >
        <span className='p12'>Have an activation code?</span>
        <span>Redeem Now</span>
      </Button>
    </If>
  );
}

export default memo(RedeemCta);
